import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { UserActions } from "../../../store/user";


const CustomerQuestions = ({ setIndex }) => {
    const dispatch = useDispatch();
    const userEmail = useSelector((state) => state.User.userEmail);
	const userName = useSelector((state) => state.User.userName);
	const userPhone = useSelector((state) => state.User.userPhone);

    const [warningPhone, setWarningPhone] = React.useState(false);



    const handleNext = (e) => {
        e.preventDefault();
        setIndex(0);
        localStorage.setItem('email', userEmail);
    }

    const handleUserName = (e) => {
        const value = e.target.value;
        dispatch(UserActions.setUserName(value));
    };
    const handleUserEmail = (e) => {
        const value = e.target.value;
        dispatch(UserActions.setUserEmail(value));
    };
    const handleUserPhone = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            dispatch(UserActions.setUserPhone(value));
            setWarningPhone(false);
        }else{
            setWarningPhone(true);
        }
    };


    return (
        <div className='flex justify-center items-center flex-col align-center mt-2 md:mt-8'>
            <span className="text-sm text-center font-bold my-3">Before we begin, please fill the information</span>
            <div className="flex flex-col w-[85%] mt-2">
                <label className="text-sm font-bold">Full name</label>
                <input 
                type='text'
                name="name"
                value={userName}
                className="w-[100%] mt-2 md:mb-2 max-sm:mb-2 border py-2 px-3 border-dark/30 rounded-md p-3 outline-none"
                onChange={handleUserName}
                />
            </div>
            <div className="flex flex-col w-[85%]">
                <label className="text-sm font-bold">Email</label>
                <input 
                type='email'
                name="email"
                value={userEmail}
                className="w-[100%] mt-2 md:mb-2 max-sm:mb-2 border py-2 px-3 border-dark/30 rounded-md p-3 outline-none"
                onChange={handleUserEmail}
                />
            </div>
            <div className="flex flex-col w-[85%]">
                <label className="text-sm font-bold">phone</label>
                <input 
                type='text'
                name="phone"
                value={userPhone}
                className="w-[100%] mt-2 md:mb-2 max-sm:mb-2 border py-2 px-3 border-dark/30 rounded-md p-3 outline-none"
                onChange={handleUserPhone}
                />
                {warningPhone ? (<div className="text-danger font-bold">* please type a valid phone number</div>):(<></>)}
            </div>
            <div className='md:relative absolute md:bottom-0 bottom-10 md:mt-5 mt-12 flex h-[30%] w-[85%] items-end'>
                <div className='flex w-full md:justify-end justify-end'>
                    <button 
                        className={`py-3 text-center rounded-sm w-[20%] hover:bg-secondary bg-secondary/70 text-white`}
                        onClick={(e) => handleNext(e)}
                        >
                            {' '}
                            <span>NEXT</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CustomerQuestions
